import {Box} from '@mantine/core';
import type React from 'react';
import type {Dispatch, SetStateAction} from 'react';
import {CONSULTANT_INDUSTRIES} from '../../../../../core/entities/company/constants';
import type {IndustryCategoriesReturnValueType} from '../../../../../core/repositories/reportsRepository';
import {isDeepEqualNumberArray} from '../../../../../shared/services/isDeepEqual';

type Props = {
  industryCategoryId: number;
  setIndustryCategoryId: Dispatch<SetStateAction<number>>;
  industryIds: number[];
  setIndustryIds: Dispatch<SetStateAction<number[]>>;
  industryCategories?: IndustryCategoriesReturnValueType;
  isEngineerUser: boolean;
  isEngineerCompany: boolean;
  setIsEngineerCompany: Dispatch<SetStateAction<boolean>>;
};

export const FollowRankingTagSelector: React.FC<Props> = ({
  industryCategoryId,
  setIndustryCategoryId,
  industryIds,
  setIndustryIds,
  industryCategories,
  isEngineerUser,
  isEngineerCompany,
  setIsEngineerCompany,
}) => {
  const categories = industryCategories?.ok
    ? industryCategories.value.industryCategories.filter(
        (category) => category.id !== 1,
      )
    : [];

  const commonStyle =
    'text-base text-primary font-bold border-2 border-primary rounded-[20px] px-8 py-4 pc:px-16 pc:py-8 text-nowrap hover:cursor-pointer';

  const isAllIndustrySelected = () => {
    return (
      industryCategoryId === 0 && industryIds.length === 0 && !isEngineerCompany
    );
  };

  const isIndustryCategorySelected = (id: number) => {
    return industryCategoryId === id && !isEngineerCompany;
  };

  const isIndustrySelected = (ids: number[]) => {
    return isDeepEqualNumberArray(ids, industryIds) && !isEngineerCompany;
  };

  return (
    <Box className="w-full pc:w-[1072px] pc:p-16 bg-white pc:rounded-16 pc:shadow-card">
      <Box className="flex justify-around gap-8 overflow-x-scroll">
        <button
          key={0}
          type="button"
          className={`${commonStyle} ${isAllIndustrySelected() ? 'bg-primary text-white' : 'bg-white'}`}
          onClick={() => {
            setIndustryIds([]);
            setIndustryCategoryId(0);
            setIsEngineerCompany(false);
          }}
        >
          全業界
        </button>
        {isEngineerUser && (
          <button
            type="button"
            className={`${commonStyle} ${isEngineerCompany ? 'bg-primary text-white' : 'bg-white'}`}
            onClick={() => {
              setIndustryCategoryId(0);
              setIndustryIds([]);
              setIsEngineerCompany(true);
            }}
          >
            エンジニア
          </button>
        )}
        {CONSULTANT_INDUSTRIES.map((industry) => (
          <button
            key={industry.ids[0]}
            type="button"
            className={`${commonStyle} ${isIndustrySelected(industry.ids) ? 'bg-primary text-white' : 'bg-white'}`}
            onClick={() => {
              setIndustryIds(industry.ids);
              setIndustryCategoryId(0);
              setIsEngineerCompany(false);
            }}
          >
            {industry.name}
          </button>
        ))}
        {categories.map((category) => (
          <button
            key={category.id}
            type="button"
            className={`${commonStyle} ${isIndustryCategorySelected(category.id) ? 'bg-primary text-white' : 'bg-white'}`}
            onClick={() => {
              setIndustryCategoryId(category.id);
              setIndustryIds([]);
              setIsEngineerCompany(false);
            }}
          >
            {category.name}
          </button>
        ))}
        {!isEngineerUser && (
          <button
            type="button"
            className={`${commonStyle} ${isEngineerCompany ? 'bg-primary text-white' : 'bg-white'}`}
            onClick={() => {
              setIndustryCategoryId(0);
              setIndustryIds([]);
              setIsEngineerCompany(true);
            }}
          >
            エンジニア
          </button>
        )}
      </Box>
    </Box>
  );
};
